import { render, staticRenderFns } from "./changeLog.vue?vue&type=template&id=316abf75&scoped=true&"
import script from "./changeLog.vue?vue&type=script&lang=js&"
export * from "./changeLog.vue?vue&type=script&lang=js&"
import style0 from "./changeLog.vue?vue&type=style&index=0&id=316abf75&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316abf75",
  null
  
)

export default component.exports